
import { normalizeString } from "@/helpers/formatText";
import setDataObject from "../components/HolidayPublic/helpers/setDataObject";
import Template from "../components";
import { sizeBanner } from "@/shared/DFP/Services/mapping";

export const useService = (props) => {

    const { content, ...rest } = props;

    const {
        adsPath = "",
        breadcrumb = [],
        data = {},
        meta = [],
        section = "",
        slug = "",
        template,
        title = "",
        titleHeader = "",
        titleHeaderTag,
        titleHeaderLink,
        widthFull = false,
        sectionAds = "",
        showGoolgeOneTap = true,
        autorefresh = true,
        width100 = false,
        bannersOn = true,
        enableHeader = true,
        enableFooter = true,
        pageType = "",
        bannerLogo = false,
     } = rest?.properties?.service;

    const bucketsHeader = rest?.properties?.bucketsHeader
        ? rest.properties.bucketsHeader
        : { liveblogs: [], urgent: [] };

    const menu = rest?.menu ?? {};

    const nameServiceMenu = "servicio" + section;

    let serviceMenu = {};
    if (menu?.[nameServiceMenu]) {
        serviceMenu = menu[nameServiceMenu];
    } else {
        serviceMenu = Object.keys(menu)
            ?.filter((key) => nameServiceMenu.includes(key))
            ?.reduce((obj, key) => {
                obj = menu[key];
                return obj;
            }, "");
    }
    const submenu = !!serviceMenu
        ? serviceMenu?.item?.items
        : menu?.serviciosmenu?.item?.items;       

    // Establecer la hora a las 09:00 AM
    const published = new Date(Date.now());
    published.setHours(9);
    published.setMinutes(0);
    published.setSeconds(0);
    const publishedDate = published.toISOString();

    const dataAnalitics = {
        pageType: "service",
        //nsSite: "clarin",
        nsSite: (normalizeString(section) != "claringrilla" ? "clarin-" + normalizeString(section) : "clarin-juegos"),
        sections: normalizeString(section),
        publishedDate,
    };

    console.log("DATAANALITICS", dataAnalitics);

    const dataSchema = {
        authors: "",
        keywords: "",
        lastModified: "",
        publishedDate: publishedDate,
        lastModified: publishedDate,
        related: "",
        subtitle: "",
        menu: submenu,
        sectionUrl: process.env.NEXT_PUBLIC_DOMAIN_URL + "/" + section,
        sections: [],
        title: title,
        summary: "",
        url: process.env.NEXT_PUBLIC_DOMAIN_URL + "/" + section,
        related_image_url: process.env.NEXT_PUBLIC_DOMAIN_URL + "/img/default.svg",
    };

    const dataMeter = {
        metadata: "",
        pageType: "home",
        section: slug?.replace(/\//g, ","),
        mainSectionTree: "",
        authors: null,
        paywall: showGoolgeOneTap ? "free" : "register-only",
        sectionNames: normalizeString(section),
        category: !!pageType ? pageType : "servicio",
    };

    const getUrlCanonical = meta?.filter((url) => url.property == "og:url");

    const getSummary = meta?.filter((summary) => summary.property == "og:description");

    const getKeywords = meta?.filter((key) => key.name == "keywords");

    const urlCanonical = getUrlCanonical?.[0]?.content
        ? getUrlCanonical[0].content
        : "https://www.clarin.com";

    const summary = getSummary?.[0]?.content ?? "";

    const keywords = getKeywords?.[0]?.content ?? "";

    const sectionSchema = !!urlCanonical
        ? urlCanonical?.replace("https://www.clarin.com/", "")
        : section;

    const sectionData = {
        name: titleHeader,
        url: sectionSchema,
    };

    const holidaysData = (section == "feriados") && setDataObject(data?.holidaysData);
    const month = holidaysData?.calendarDays;

    let isHoroscope;
    if (section == "horoscopo-chino" || section == "horoscopo") {
        isHoroscope = true;
    }

    let isEconomiaDivisas;
    if (breadcrumb?.[0]?.url == "/economia/divisas-acciones-bonos") {
        isEconomiaDivisas = true;
    }

    let body =
        (section == "horoscopo-chino") &&
        data?.sign?.[0]?.characteristics?.[0]?.content;
    if (!body) {
        const bodyMap =
            (section == "horoscopo") &&
            data?.sign?.[0]?.data
                ?.map((item) => `${item.nombre}:\n${item.descripcion}\n`)
                ?.join("\n");
        body = bodyMap;
    }

    const calendar =
        (section == "feriados") &&
        month?.map((content) => {
            let data = {
                title: `${content.monthName}`,
                url: `/feriados/${content.year}/${content.monthName.toLowerCase()}`,
                summary: `Calendario con todos los feriados de ${content.monthName} ${content.year} en Argentina`,
            };
            return data;
        });

    let newContent = Array.isArray(data?.notes) ? data.notes : [];
    if(!!calendar){
        newContent = [...newContent, ...calendar];
    }

    return {
        ...rest,
        preview: rest?.preview ?? false,
        isPreview: rest?.preview ?? false,
        widgets: rest?.widgets ?? [],
        menu,
        formatContent: {
            content: newContent,
            urlCanonical,
            sectionData,
            isHoroscope,
            isEconomiaDivisas,
            publishedDate,
            summary,
            body,
            keywords,
            dataAnalitics,
            dataMeter,
            sectionNameAds: sectionAds ? sectionAds : section,
            adsPath,
            sizeBanner,
            submenu,
            title: titleHeader,
            tag: titleHeaderTag,
            linkTitle: titleHeaderLink,
            section: section,
            routesBreadcrumb: breadcrumb,
            dataSchema,
            componentTemplate: Template?.[template],
            enableFooter,
            autorefresh,
            bannersOn,
            widthFull,
            enableHeader,
            width100,
            dataHeader: {
                liveblogs: bucketsHeader?.liveblogs,
                menu,
                sectionData,
                showGoolgeOneTap,
                newsToday: menu?.noticiashoy?.item?.items,
                bannerHorizantalOneEnable: bannersOn,
            },
            customSection: {
                sponsor: bannerLogo,
            }
        },
    }
}